import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

class HeadPoster extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        /**
         * 组件分发数据
         */
        const { headPoster } = this.props.content;

        return (
            <div
                className={styles.headPoster}
                style={{ background: `url(${headPoster.imgUrl}) no-repeat center top` }}
            />
        );
    }
}

const HeadPosterChip = props => {
    return (
        <Fragment>
            <Chip id="230214" type="struct" title="美食盛典-头图" groupName="正文-首页" content={props.content}>
                {null}
            </Chip>
            <HeadPoster content={props.content} />
        </Fragment>
    );
};

HeadPosterChip.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(HeadPoster);
